/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface SurfaceStreamZoneTickerItem
 */
export interface SurfaceStreamZoneTickerItem {
    /**
     * 
     * @type {string}
     * @memberof SurfaceStreamZoneTickerItem
     */
    text: string;
    /**
     * 
     * @type {string}
     * @memberof SurfaceStreamZoneTickerItem
     */
    color?: SurfaceStreamZoneTickerItemColorEnum;
}


/**
 * @export
 */
export const SurfaceStreamZoneTickerItemColorEnum = {
    orange: 'orange',
    green: 'green',
    red: 'red'
} as const;
export type SurfaceStreamZoneTickerItemColorEnum = typeof SurfaceStreamZoneTickerItemColorEnum[keyof typeof SurfaceStreamZoneTickerItemColorEnum];


/**
 * Check if a given object implements the SurfaceStreamZoneTickerItem interface.
 */
export function instanceOfSurfaceStreamZoneTickerItem(value: object): value is SurfaceStreamZoneTickerItem {
    if (!('text' in value) || value['text'] === undefined) return false;
    return true;
}

export function SurfaceStreamZoneTickerItemFromJSON(json: any): SurfaceStreamZoneTickerItem {
    return SurfaceStreamZoneTickerItemFromJSONTyped(json, false);
}

export function SurfaceStreamZoneTickerItemFromJSONTyped(json: any, ignoreDiscriminator: boolean): SurfaceStreamZoneTickerItem {
    if (json == null) {
        return json;
    }
    return {
        
        'text': json['text'],
        'color': json['color'] == null ? undefined : json['color'],
    };
}

export function SurfaceStreamZoneTickerItemToJSON(json: any): SurfaceStreamZoneTickerItem {
    return SurfaceStreamZoneTickerItemToJSONTyped(json, false);
}

export function SurfaceStreamZoneTickerItemToJSONTyped(value?: SurfaceStreamZoneTickerItem | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'text': value['text'],
        'color': value['color'],
    };
}

